import { useToast } from '@chakra-ui/react';
import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

type AssignBody = { user_id?: number; force?: boolean; updated_at: string };
async function assign(axios: AxiosInstance, id: number, body: AssignBody): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/task/${id}/assign`, body);
  return data;
}

export default function useAssignMutation(id: number, queryKey: QueryKey) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationKey: ['Assign'],
    mutationFn: (body: AssignBody) => assign(axios, id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error);
    },
  });
}
